import React, { Component } from "react";
import { Form, FormControl, Container, Button, Navbar, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';
import { Markup } from 'interweave';


class Header extends Component {

  


  render() {

    var navbarStyle =  { minHeight:"80px"}
    var s = {color:"#ccc", margin:"0 20px 0px 0px"};
      
    var headerLinks = [];
    headerLinks.push(<Nav.Link id={"link_x"} key={"link_x"} href={"xxx"} style={{fontWeight:"bold"}} style={s}>xxxx</Nav.Link>);
    
    var logoUrl = "xxx";

    return (
      <Navbar className="globalheader"  variant="dark" expand="lg" 
        style={navbarStyle}
        >
        <Container fluid>
          <Navbar.Brand href={logoUrl} className="globalheader_logo">
            xxxxx
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="me-auto my-2 my-lg-0" navbarScroll style={{fontSize:"22px", margin:"0px 0px 0px 30px"}}>
              {headerLinks}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default Header;
